import { useCallback, useEffect, useMemo, useState } from 'react';
import { accumulateStudySeconds } from '../lib/studyTime';

export function useLessonStudy() {
  const [startedAt] = useState(() => Date.now());
  const [blockStartedAt, setBlockStartedAt] = useState<Record<string, number>>({});
  const [blockSeconds, setBlockSeconds] = useState<Record<string, number>>({});
  const [clockNow, setClockNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setClockNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  const beginBlock = useCallback((blockId: string) => {
    setBlockStartedAt((current) => ({ ...current, [blockId]: current[blockId] || Date.now() }));
  }, []);

  const completeBlockTimer = useCallback((blockId: string, explicitSeconds = 0) => {
    const measuredSeconds = blockSeconds[blockId] || 0;
    const seconds = explicitSeconds > 0 ? explicitSeconds : accumulateStudySeconds(measuredSeconds, blockStartedAt[blockId], Date.now());
    setBlockSeconds((current) => ({ ...current, [blockId]: seconds }));
    setBlockStartedAt((current) => {
      const next = { ...current };
      delete next[blockId];
      return next;
    });
    return seconds;
  }, [blockSeconds, blockStartedAt]);

  const totalSeconds = useMemo(() => {
    const ids = new Set([...Object.keys(blockSeconds), ...Object.keys(blockStartedAt)]);
    return [...ids].reduce((sum, blockId) => sum + accumulateStudySeconds(blockSeconds[blockId] || 0, blockStartedAt[blockId], clockNow), 0);
  }, [blockSeconds, blockStartedAt, clockNow]);

  return { startedAt, blockStartedAt, blockSeconds, totalSeconds, beginBlock, completeBlockTimer };
}
